export const useStoreEvent = defineStore('StoreEvent', {
    state: () => ({
        event: null,
        disabled: null,
        error: null,
    }),
    actions: {
        async getEvent(eventSlug) {
            this.error = null;
            if (this.event?.event_slug !== eventSlug) {
                this.event = null;
            }
            ({event: this.event, error: this.error} = await useEntityEvent().get(eventSlug));
        },
        async putEventInterest() {
            this.error = null;
            this.disabled = true;
            ({error: this.error} = await useEntityEventInterest().put(this.event.id_event));
            this.disabled = false;
            if (!this.error) this.refresh();
        },
        async deleteEventInterest() {
            this.error = null;
            this.disabled = true;
            ({error: this.error} = await useEntityEventInterest().remove(this.event.id_event));
            this.disabled = false;
            if (!this.error) this.refresh();
        },
        clearError() {
            this.error = null;
        },
        refresh() {
            if (this.event) {
                this.getEvent(this.event.event_slug).finally(() => {});
            }
        },
    },
});
